import { createContext, useContext } from 'react';

/**
 * Contexto del tema de la landing. El Landing2Layout provee { mode, setMode };
 * el Header2 (toggle) y cualquier sección que lo necesite lo consumen.
 */
export const ThemeContext = createContext({ mode: 'auto', setMode: () => {} });

export const useTheme = () => useContext(ThemeContext);
